import React from "react";
import { Drawer, DialogTitle, IconButton } from "@mui/material";
import MaquileroForm from "./MaquileroForm";
import { background_marifer } from "utils/apis";
import { Cancel } from "@mui/icons-material";
import { styles } from "utils/apis";

const AddMaquilero = ({ mode, open, handleClose }) => {

    return (
        <>
            <Drawer
                anchor={"bottom"}
                open={open}
                onClose={handleClose}
                sx={styles}     
            >
                <DialogTitle sx={{display: "flex", justifyContent: "flex-end", padding: 0}}>
                    <IconButton onClick={handleClose} sx={{color:"purple"}}>
                        <Cancel />
                    </IconButton>
                </DialogTitle>
                <MaquileroForm mode={mode} handleClose={handleClose} />
            </Drawer>
        </>
    )
}
export default AddMaquilero;